const modal_close_btn = document.querySelectorAll(".close-modal-btn");
const modalOpenBtn = document.querySelectorAll(".modal-btn");
const modalContentBox = document.querySelectorAll(".modal-content");
const modalContainer = document.querySelector(".modal-section-container");
const overlay = document.querySelector(".overlay");
let curModel = 0;

console.log(modalOpenBtn);
console.log(modalContentBox);
modalOpenBtn.forEach((e, pi) =>
  e.addEventListener("click", function (f) {
    curModel = pi;
    // console.log(pi);
    modalContentBox.forEach((modal, index) => {
      // console.log(index);
      if (index === pi) {
        console.log(modal);
        modal.style.opacity = "1";
        modal.style.zIndex = "50";
      } else {
        modal.style.opacity = "0";
        modal.style.zIndex = "-50";
      }
    });

    overlay.style.display = "block";
  })
);
modal_close_btn.forEach((btn) =>
  btn.addEventListener("click", function () {
    modalContentBox.forEach((modal) => {
      modal.style.opacity = "0";
      modal.style.zIndex = "-10";
    });
  })
);

modalContentBox.onclick = function (event) {
  event.stopPropagation();
};
overlay.addEventListener("click", function () {
  overlay.style.display = "none";
  console.log(modalContentBox[curModel]);
  modalContentBox[curModel].style.opacity = "0";
  modalContentBox[curModel].style.zIndex = "-10";
});
